// extracted by mini-css-extract-plugin
export default {"root":"ThreadMessageActions_root__BlNHd"};